export const providers = {
  SMARTICO: 'Smartico',
  ZIQNI: 'Ziqni',
};
